<script>
	import options from './TableComponentGeneric.options'
	export default options
</script>

<template>

	<table class="nlx-order-history-table__table">
		<tr>
			<template v-for="(tableHeaderData, index) in tableData.columns" :key="index">
				<th class="nlx-order-history-table__table-header">{{getLabel(`${tableHeaderData.id}`)}}</th>
			</template>
		</tr>

		<template v-for="(tableCellData, index) in tableData.entries" :key="index">
			<tr>
				<template v-for="(cellValue, index) in Object.values(tableCellData)" :key="index">
					<td v-if="cellValue && isCellValueAButton(cellValue)" class="nlx-order-history-table__table-cell nlx-order-history-table__table-cell--button">
						<a :href="cellValue.href" class="nlx-button nlx-order-history-table__button" :class="determineButtonColor(cellValue.color)">{{cellValue.formatted}}</a>
					</td>
					<td v-else-if="cellValue && isCellValueAnInputField(cellValue)" class="nlx-order-history-table__table-cell">
						<input type="number" v-model="cellValue.value" :disabled="cellValue.disabled">
					</td>
					<td v-else-if="cellValue && isCellValueAStockLabel(cellValue)" class="nlx-order-history-table__table-cell">
                		<InStockLabel :in-stock="cellValue.inStock" :formatted="cellValue.formatted" :formatted-available-date="cellValue.formattedAvailableDate" />
					</td>
					<td v-else class="nlx-order-history-table__table-cell">{{cellValue}}</td>
				</template>
			</tr>
		</template>
	</table>

</template>
